<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import flexible from '../static/js/flexible'
export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import '../static/css/normalize.css';
  @import '../static/css/common.scss';
#app {
  position: relative;
  font-family: 'PingFangSC', 'arial', Helvetica, sans-serif, 'Microsoft YaHei';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  padding: pxtorem(20) pxtorem(24);
  margin: pxtorem(36) auto 0 auto;
  max-width: pxtorem(648);
  min-height: pxtorem(1000);
  background-color: #fff;
  border-radius: 4px;
  border: solid 1px #dedee1;
  box-shadow: 0 0 10px 3px #dedee1;
}
  .footer {
   position: absolute;
   left: 0;
   right: 0;
   bottom: pxtorem(-110);
   margin: 0 auto;
   padding-bottom: pxtorem(50);
 @include font-dpr(16);

  .ftext {
    padding: 0 pxtorem(40);
    display: inline-block;
    color: #009fe1;
  }

  a {
    border-right: pxtorem(2) solid #dedee1;
  }

  a:last-child {
    border-right: 0;
  }

  }
</style>



// WEBPACK FOOTER //
// src/App.vue